<template>
  <div class="" style="overflow: auto; padding-bottom: 100px" >
    <!-- <b-row class="m-0 pt-4 mt-2 px-5 justify-content-between">
      <div @click="$router.push('/').catch(err => {})">
        <b-img-lazy :src="require(`@/assets/logos/eatDoradoText.png`)" style="max-height: 50px; cursor: pointer; z-index: 1000" fluid alt="eatDorado Logo"></b-img-lazy>  
      </div>
    </b-row> -->

    <b-row class="m-0 justify-content-center" v-if="order">
      <div style="width: 1600px; max-width: 100%">
        <b-row class="m-0 justify-content-center" style="margin-top: 100px !important">
          <b-col cols="12" class="" style="z-index: 1000 !important">
            <div class="mt-3 mt-lg-4 shadow bg-white rounded p-3">
              <div class="m-4" v-if="appversion">
                <h3 class="text-center text-danger" v-if="appversion.confirmation_required == false">ACHTUNG! <br> <br> Aktuell werden keine Bestätigungs-SMS der Restaurants versendet! <br> <br> Bitte aktualisieren Sie diese Seite um den Status Ihrer Bestellung abzufragen.</h3>
                <h5 class="text-center mt-3 pb-3" v-if="appversion.confirmation_required == false">Sollten Zweifel zur Bestellung bestehen, rufe bitte das Restaurant direkt an: <br> <br> {{ order.company.contact.phone }}</h5>
              </div>
              
              <h3 class="text-center">Vielen Dank!</h3>
              <p class="text-center mb-5">Mit dieser Bestellung unterstützt Du ein lokales Restaurant ❤️</p>
              <h3 class="text-center mb-4">Deine Bestellung bei {{ order.company.title }}:</h3>
              <h5 class="text-center mb-4">{{order.addressData ? 'Deine ungefähre Lieferzeit: ' : 'Deine Abholzeit: '}}{{order.delivery_time | moment('DD.MM.YYYY HH:mm')}}</h5>
              <div class="mx-2">
                <div class="" v-for="(item) in order.items" :key="item.index">
                  <b-row class="m-0 p-0 justify-content-between" >
                    <p class="m-0" :key="item.amount">{{ item.amount }} x 
                    </p>
                    <h5 class="m-0">{{ item._id.title }}</h5>
                    <h5 class="m-0">{{ item._id.price.toFixed(2) }}€</h5>
                  </b-row>

                    <b-form-textarea
                      class="mt-2"
                      v-if="item._id.note"
                      disabled
                      id="textarea"
                      v-model="item._id.note"
                      placeholder="Hinweis für das Restaurant. z.B: Ohne Zwiebeln, mit Käse..."
                      rows="2"
                      max-rows="6"
                    ></b-form-textarea>

                    <b-row class="m-0 mt-3 justify-content-between" v-if="item.extras">
                      <div v-for="(extra, index) in item.extras" class="w-100" :key="extra.index">
                        <b-row class="m-0 mt-1 justify-content-between">
                          <p v-if="extra.choosen" class="m-0"> </p>
                          <p v-if="extra.choosen" class="m-0">{{ extra.title }}</p>
                          <!-- <p v-if="extra.choosen" class="m-0">{{ extra.price.toFixed(2) }}€</p> -->
                          <p v-if="extra.choosen" class="m-0">{{ getSingleExtraPrice(item, index) }}€</p>
                        </b-row>
                      </div>
                    </b-row>
                    <b-row class="m-0 mt-3 justify-content-between" v-for="variant in item.variants" :key="variant.index">
                      <div  class="w-100" >
                        <b-row class="m-0 mt-1 justify-content-between">
                          
                          <p v-if="variant.choosen" class="m-0"></p>
                          <p v-if="variant.choosen" class="m-0">{{ variant.choosen.title }} </p>
                          <p v-if="variant.choosen" class="m-0">{{ variant.choosen.price.toFixed(2) }}€</p> 
                        </b-row>
                      </div>
                    </b-row>

                    <div v-if="item.extras.filter(el => el.choosen).length > 0 || item.variants.filter(el => el.choosen).length > 0">
                      <b-row class="m-0 mt-3 mb-5 justify-content-end">
                        <h5 class="m-0">{{ getExtrasPrice(item) }}€</h5>
                      </b-row>
                    </div>
                    <hr>                    

                </div>
                
                <!-- <hr class="m-2"> -->
                <b-row class="m-0 justify-content-between w-100" v-if="order.delivery_fee > 0">
                  <h5>Liefergebühr:</h5>
                  <h5>{{ order.delivery_fee.toFixed(2) }}€</h5>
                </b-row>
                <b-row class="m-0 justify-content-between w-100">
                  <h3>Gesamtpreis:</h3>
                  <h3>{{ totalPrice }}€</h3>
                </b-row>
              </div>
              <h3 class="text-center my-3">Bestellstatus</h3>
              <div v-if="order.status != 'storniert'">
              <form-wizard 
                title=""
                subtitle=""
                back-button-text="zurück"
                next-button-text="weiter"
                finish-button-text="Fertigstellen"
                color="rgba(255,193,7,1)"
                :startIndex="tab"
              >
                  <wizard-step 
                      slot-scope="props"
                      slot="step"
                      :tab="props.tab"
                      :transition="props.transition"
                      :index="props.index">
                  </wizard-step>

                  <tab-content title="Bestellung aufgegeben" icon="ti-shopping-cart" :before-change="validateAsyncStep1">
                    <div v-if="!order.addressData">
                      <p class="mt-2 text-center">Du hast deine Bestellung aufgegeben und {{order.customer_verified ? 'sie bestätigt.' : 'musst sie noch bestätigen.'}} </p>
                      <p class="mt-2 text-center">Das Restaurant {{order.status == 'bestätigt' ? 'hat deine Bestellung und den Abholtermin am: ' + getDateOfOrder(order.date) + ' um ' + order.time + ' Uhr bestätigt.' : 'muss deine Bestellung noch bestätigen.'}} </p>
                    </div>
                    <div v-else>
                      <p class="mt-2 text-center">Du hast deine Bestellung aufgegeben und {{order.customer_verified ? 'sie bestätigt.' : 'musst sie noch bestätigen.'}} </p>
                      <p class="mt-2 text-center">Das Restaurant {{order.status == 'bestätigt' ? 'hat deine Bestellung bestätigt.' : 'muss deine Bestellung noch bestätigen.'}} </p>
                      <p class="text-center mb-4">{{order.addressData ? 'Deine ungefähre Lieferzeit: ' : 'Deine Abholzeit: '}}{{order.delivery_time | moment('DD.MM.YYYY HH:mm')}}</p>
                    </div>
                    
                    <div v-if="order.customer_verified">
                      
                    </div>
                    <div v-else>
                      <h3 class="text-center ">Wir haben Dir einen Bestätigungscode per SMS gesendet.</h3>
                      <p class="text-center mb-5">Dieser Code ist 5 Minuten lang gültig, danach wird deine Bestellung automatisch storniert.</p>
                      <h4 class="text-center">Bitte gib den Code ein:</h4>
                      <p v-if="orderState.verified === false" class="text-center text-danger">{{ orderState.message }}</p>
                      <b-row class="m-0 my-5 justify-content-center">
                        
                        <Sms v-model="securityCode"></Sms>
                      </b-row>
                      <p class="text-center custom-nav" @click="resendCode">Code <span v-if="timer > 0">in {{timer}} Sekunden</span> erneut schicken</p>
                      <b-row class="m-0 justify-content-center">
                        <b-col cols="12" lg="6">
                          <div class="order-button shadow" @click="confirmOrder()" :class="securityCode.length == 6 ? 'linear-warning hover' : 'bg-secondary forbidden'">
                            <b-row class="m-0 justify-content-center mt-2 " >
                              <h5 v-if="!updating" class="mt-2 pt-1 text-center" >Bestellung bestätigen</h5>
                              <h5 v-if="updating" class="mt-2 pt-1 text-center"><b-spinner label="Spinning"></b-spinner></h5>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                     
                    </div>
                                      
                  </tab-content>

                  <tab-content title="Bestellung bestätigt" icon="ti-check" :before-change="validateAsyncStep2">
                    <div v-if="!order.addressData">
                      <p class="mt-2 text-center">Das Restaurant {{order.status == 'bestätigt' ? 'hat deine Bestellung und den Abholtermin am: ' + getDateOfOrder(order.date) + ' um ' + order.time + ' Uhr bestätigt.' : 'muss deine Bestellung noch bestätigen.'}} </p>
                    </div>
                    <div v-else>
                      <p class="mt-2 text-center">Das Restaurant {{order.status == 'bestätigt' ? 'hat deine Bestellung bestätigt.' : 'muss deine Bestellung noch bestätigen.'}} </p>
                      <p class="text-center mb-4">{{order.addressData ? 'Deine ungefähre Lieferzeit: ' : 'Deine Abholzeit: '}}{{order.delivery_time | moment('DD.MM.YYYY HH:mm')}}</p>
                    </div>

                    <div v-if="!order.addressData">
                      <h4 class="mt-4 text-center">Abholadresse:</h4>
                      <p class="m-0 mt-4 text-center">{{order.company.adress.street}}</p>
                      <p class="m-0 text-center">{{order.company.adress.zipcode}}, {{order.company.adress.city}}</p>
                      <p class="m-0 mt-4 text-center" v-if="order.company.contact.mobile">Tel: {{order.company.contact.mobile}}</p>
                      <p></p>
                    </div>
                    <div v-else>
                      <h4 class="mt-4 text-center">Lieferadresse:</h4>
                      <p class="m-0 mt-4 text-center">{{order.addressData.locality}}</p>
                    </div>
                    
                  </tab-content>

                  <tab-content :title="order.addressData ? 'Bestellung geliefert' : 'Bestellung abholbereit'" icon="ti-car">
                    <div v-if="order.status == 'bereit' && !order.addressData">
                      <p class="my-5 text-center">Deine Bestellung ist abholbereit!</p>
                      <h4 class="mt-4 text-center">Abholadresse:</h4>
                      <p class="m-0 mt-4 text-center">{{order.company.adress.street}}</p>
                      <p class="m-0 text-center">{{order.company.adress.zipcode}}, {{order.company.adress.city}}</p>
                      <p class="m-0 mt-4 text-center" v-if="order.company.contact.mobile">Tel: {{order.company.contact.mobile}}</p>
                    </div>
                    <div v-if="order.status == 'abgeholt'">

                      <p class="text-center" v-if="!order.addressData">Du hast Deine Bestellung abgeholt.</p>
                      <p class="text-center" v-else>Deine Bestellung wurde geliefert.</p>

                      <div v-if="!order.customer_rated">
                        <p class="m-0 my-2 text-center">Möchtest Du die Bestellung bei {{ order.company.title }} bewerten?</p>
                        <b-row class="m-0 justify-content-center">
                          <b-form-rating style="width: 300px" class="hover text-center" size="lg" :no-border="true" variant="warning" v-model="ratingForm.rating"></b-form-rating>
                        </b-row>
                        <b-row class="m-0 mt-3 justify-content-center">
                          <b-form-group
                            description="Diese Nachricht kann jeder lesen."
                          >
                            <b-form-textarea
                              style="width: 300px"
                              id="textarea"
                              v-model="ratingForm.message"
                              placeholder="Nachricht eingeben (optional)"
                              rows="3"
                              max-rows="6"
                            ></b-form-textarea>
                          </b-form-group>
                        </b-row>
                        <b-row class="m-0 mt-3 justify-content-center">
                          <b-form-group
                            description="Diese Nachricht kann nur das Restaurant lesen."
                          >
                            <b-form-textarea
                              style="width: 300px"
                              id="textarea"
                              v-model="ratingForm.hint"
                              placeholder="Lob oder Kritik für das Restaurant? (optional)"
                              rows="3"
                              max-rows="6"
                            ></b-form-textarea>
                          </b-form-group>
                        </b-row>
                        <b-row class="m-0 mt-3 justify-content-center">
                          <b-form-checkbox
                            id="checkbox-1"
                            v-model="ratingForm.anonymous"
                            name="checkbox-1"
                          >
                            Meinen Namen in der Bewertung anzeigen (optional)
                          </b-form-checkbox>
                        </b-row>
                        <b-row class="m-0 mt-3 justify-content-center">
                          <b-button :disabled="ratingForm.rating == 0" variant="warning" @click="postRating()">
                            Bestellung bewerten <b-spinner v-if="updating" label="Spinning"></b-spinner>
                          </b-button>
                        </b-row>
                      </div>
                      <div v-else>
                        <h4 class="mt-4 text-center">Vielen Dank für Deine Bewertung!</h4>
                      </div>
                    </div>
                  </tab-content>
              </form-wizard>

               <b-row class="m-0 justify-content-center my-4" v-if="this.order.status != 'abgeholt'">
                <b-button variant="warning" @click="refreshPage()">
                  Bestellung aktualisieren <b-spinner v-if="updating" label="Spinning"></b-spinner>
                </b-button>
              </b-row>

              </div>
              <div v-else>
                <h3 class="text-center text-danger"> 
                  Die Bestellung wurde storniert und ist ungültig.
                </h3>
                <p class="text-center">Wenn du willst, kannst du erneut Bestellen.</p>
              </div>

             
              
            </div>
          </b-col>      
        </b-row>
      </div>
    </b-row>

    <b-row class="m-0 justify-content-center" v-if="!order && !updating">
      <div style="width: 1600px; max-width: 100%">
        <b-row class="m-0 justify-content-center" style="margin-top: 100px !important">
          <b-col cols="12" lg="12" style="z-index: 1000 !important">
            <div class="mt-3 shadow bg-white rounded p-3">
              <b-row class="m-0 my-5 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_searching.svg`)" style="height: 150px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h3 class="text-center my-2">Diese Bestellung gibt es scheinbar nicht...</h3>
              <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2">

              </div>
            </div>
          </b-col>      
        </b-row>
      </div>
    </b-row>

    <div style="height: 60vh; max-height: 60vh; overflow-y: auto; z-index: 1000 !important" class="pt-2" v-if="updating">
      <loading-overlay :text="'lade Bestellung...'" />
    </div>
    
    <Footer class="my-5"></Footer>

  </div>
</template>

<script>

import Footer from '@/components/Footer'
import LoadingOverlay from '../shared/animations/loadingOverlay.vue'
import Sms from '../shared/plugins/security/src/security';
// import CheckAnimation from '../shared/animations/checkAnimation'

export default {
  name: 'Bestellung',
  components: {
    Footer,
    LoadingOverlay,
    Sms,
    // CheckAnimation
  },
  data: () => {
    return {
      timer: 300,
      securityCode: '',
      code: null,
      ratingForm: {
        rating: 0,
        message: '',
        anonymous: false
      }
    }
  },
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {

    totalPrice(){
      var total = 0.00
      if(!this.order) return total
      if(this.order.items.length == 0) return total

      this.order.items.forEach(item => {
        total += item._id.price * item.amount
        if(item.extras){
          item.extras.forEach(extra => {
            if(extra.choosen){
              total += extra.price * item.amount
              if(item.variants.length > 0){
                item.variants.forEach(variant => {
                  if(variant.choosen){
                    total += variant.choosen.extra_price * item.amount
                  }
                })
              }
            }
          })
          if(item.variants.find(variant => variant.choosen)){
            item.variants.filter(variant => variant.choosen).forEach(element => {
              total += element.choosen.price * item.amount
            })
          }
        }
      })
      if(this.order.delivery_fee){
        total += this.order.delivery_fee
      }
      return total.toFixed(2)
    },
 
    // totalPrice(){
    //   var total = 0
    //   if(!this.order) return total
    //   if(this.order.items.length == 0) return total

    //   this.order.items.forEach(item => {
    //     total += item._id.price * item.amount
    //     if(item.extras){
    //       item.extras.forEach(extra => {
    //         if(extra.choosen){
    //           total += extra.price * item.amount
    //         }
    //       })
    //     }
    //   })

    //   return total.toFixed(2)
    // },
    tab(){
      if(this.order.status == 'abgeholt') return 2
      if(this.order.status == 'bereit') return 2
      if(this.order.status == 'bestätigt') return 1
      return 0
    },
    updating(){
      return this.$store.getters.updating
    },
    orderState(){
      return this.$store.getters.orderState
    },
    loggedIn(){
      return this.$store.getters.loggedIn
    },
    restaurant(){
      return this.$store.getters.restaurant
    },
    order(){
      return this.$store.getters.order
    },
    appversion(){
      return this.$store.getters.appversion
    }
  },
  watch: {
    // order(){
    //   if(!this.order.customer_verified){
    //     var query = this.$route.query.code
    //     if(!query) return 
    //     this.securityCode = parseInt(query)
    //     this.confirmOrder()
    //   }
    // }
  },
  mounted(){
    this.$store.dispatch('getAppversion')
    this.setTimer()
    this.$store.commit('restaurant', null)
    this.$store.commit('orderState', {})
    this.$store.commit('order', null)
    this.$store.dispatch('getOrder', {_id: this.$route.params.id})
    // if(this.order){
    //   if(!this.order.customer_verified){
    //     var query = this.$route.query.code
    //     if(!query) return 
    //     this.securityCode = parseInt(query)
    //     this.confirmOrder()
    //   }
    // }
  },
  methods: {
    getSingleExtraPrice(item, index){
      var price = item.extras[index].price
      item.variants.forEach(variant => {
        price += variant.choosen.extra_price
      })
      return price.toFixed(2)
    },
    postRating(){
      
      const payload = {
        _id: this.order._id,
        rating: this.ratingForm.rating,
        text: this.ratingForm.message,
        anonymous: this.ratingForm.anonymous,
        hint: this.ratingForm.hint
      }
      //console.log(payload)
      this.$store.dispatch('postRating', payload)
    },
    refreshPage(){
      window.location.reload()
    },
    setTimer(){
      this.timer = 300
      var vm = this
      this.resendTimer = setInterval(function(){
        if(vm.timer <= 0){
          clearInterval(vm.resendTimer);
        }
        vm.timer -= 1;
      }, 1000);
    },
    // getExtrasPrice(menu){
    //   var price = menu._id.price
    //   menu.extras.forEach(element => {
    //     if(element.choosen){
    //       price += element.price
    //     }
    //   });
    //   return (price * menu.amount).toFixed(2)
    // },
    getExtrasPrice(menu){
      var price = menu._id.price
      menu.extras.forEach(element => {
        if(element.choosen){
          price += element.price
          if(menu.variants){
            if(menu.variants.length > 0){
              menu.variants.forEach(variant => {
                if(variant.choosen){
                  price += variant.choosen.extra_price
                }
              })
            }
          }
        }
      });
      if(menu.variants.find(variant => variant.choosen)){
        // console.log('CHOOSEN:', menu.variants.find(variant => variant.choosen).choosen)
        menu.variants.filter(variant => variant.choosen).forEach(element => {
          price += element.choosen.price 
        })
      }
      return price.toFixed(2)
    },
    getDateOfOrder(date){
      var newDate = new Date(date)
      return newDate.getDate()+'.'+(newDate.getMonth()+1)+'.'+newDate.getFullYear()
    },
    confirmOrder(){
      if(this.order.customer_verified) return
      const payload = {
        _id: this.order._id,
        data: {
          verification_number: this.securityCode
        }
      }

      this.$store.dispatch('confirmOrder', payload)
      this.$store.dispatch('getOrder', {_id: this.$route.params.id})
    },
    resendCode(){
      if(this.timer > 0) return
      this.$store.dispatch('resendConfirmation', {_id: this.$route.params.id})
    },
    validateAsyncStep1:function() {
      return new Promise((resolve, reject) => {
        if(this.order.customer_verified && this.order.status != 'bestellt') resolve(true)
        reject(false)
      })
    },
    validateAsyncStep2:function() {
      return new Promise((resolve, reject) => {
        if(this.order.status == 'completed') resolve(true)
        reject(false)
      })
    }
  }
}
</script>

<style lang="scss">
  .wizard-card-footer {
    display: none !important
  }
</style>